import { defineMessages } from 'react-intl';

export default defineMessages({
    loading: {
        id: 'ml.policychange.watercraftOperator.loading',
        defaultMessage: 'Loading...'
    },
    saving: {
        id: 'ml.policychange.watercraftOperator.saving',
        defaultMessage: 'Saving...'
    },
    makeChanges: {
        id: 'ml.policychange.watercraftOperator.makeChanges',
        defaultMessage: 'Make Changes'
    },
    nextBaseDescription: {
        id: 'ml.policychange.watercraftOperator.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.watercraftOperator.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    addWatercraftOperator: {
        id: 'ml.policychange.watercraftOperator.Add a Watercraft Operator',
        defaultMessage: 'Add a Watercraft Operator'
    },
    editWatercraftOperator: {
        id: 'ml.policychange.watercraftOperator.Edit a Watercraft Operator',
        defaultMessage: 'Edit a Watercraft Operator'
    },
    underlyingPolicyNotListed: {
        id: 'ml.policychange.watercraftOperator.Policy is not listed',
        defaultMessage: 'Policy is not listed'
    },
    addAPolicy: {
        id: 'ml.policychange.watercraftOperator.Add a Policy',
        defaultMessage: 'Add a Policy'
    },
    cancel: {
        id: 'ml.policychange.watercraftOperator.cancel',
        defaultMessage: 'Cancel'
    },
    addWatercraftOperatorDynamic: {
        id: 'ml.policychange.watercraftOperator.Add Watercraft Operator',
        defaultMessage: 'Add Watercraft Operator'
    },
    editWatercraftOperatorDynamic: {
        id: 'ml.policychange.watercraftOperator.Edit Watercraft Operator',
        defaultMessage: 'Edit Watercraft Operator'
    }    
});
